<template>
  <!-- eslint-disable -->
  <el-scrollbar class="baseinfo_list">
    <div class="baseinfo_top">
      <div class="baseinfo_each">
        <span class="title">素材名称：</span>
        <span class="name_title">{{ matterinfodata.title }}</span>
      </div>
      <div class="baseinfo_each">
        <span class="title">上传者：</span>
        <span class="name">{{ matterinfodata.creator }}</span>
      </div>
      <div class="baseinfo_each">
        <span class="title">素材标签：</span>
        <div class="tags">
          <span
            v-for="(item,index) in matterinfodata.tags"
            :key="index"
          >{{ item }}</span>
        </div>
      </div>
      <div class="baseinfo_each">
        <span class="title">关键词：</span>
        <div class="tags">
          <span
            v-for="(item,index) in matterinfodata.keywords"
            :key="index"
          >{{ item }}</span>
        </div>
      </div>
      <div class="baseinfo_each">
        <span class="title">素材描述：</span>
        <span class="name_title">{{ matterinfodata.detail }}</span>
      </div>
      <div class="baseinfo_each">
        <span class="title">上传时间：</span>
        <span class="name">{{ matterinfodata.time_create | formatTime }}</span>
      </div>
      <div
        v-if="matterinfotype === 'videoDetail' || matterinfotype === 'videoAuditDetail' || matterinfotype === 'uploadVideoDetail'"
        class="baseinfo_each"
      >
        <span
          class="title"
          style="line-height:24px;"
        >视频状态：</span>

        <span class="each_status">
          <span
            v-if="matterinfodata.flag_sign_and_issue"
            class="yes"
          >已签发</span>
          <span
            v-if="!matterinfodata.flag_sign_and_issue"
            class="unAudit"
          >未签发</span>
        </span>
        <span
          style="margin-left:20px;margin-right:20px;"
          class="each_status"
        >
          <span
            v-if="matterinfodata.flag_push==='yes'"
            class="yes"
          >已推送</span>
          <span
            v-if="matterinfodata.flag_push==='no'"
            class="unAudit"
          >未推送</span>
        </span>
        <span class="each_status">
          <span
            v-if="matterinfodata.audit_status === 'yes'"
            class="yes"
          >已通过</span>
          <span
            v-if="matterinfodata.audit_status === 'no'"
            class="no"
          >未通过</span>
          <span
            v-if="matterinfodata.audit_status === 'doing'"
            class="doing"
          >审核中</span>
          <span
            v-if="matterinfodata.audit_status === 'unAudit'"
            class="unAudit"
          >未审核</span>
        </span>
      </div>
      <div class="baseinfo_each">
        <span class="title">更新时间：</span>
        <span class="name">{{ matterinfodata.time_update | formatTime }}</span>
      </div>
      <div class="baseinfo_each">
        <span class="title">素材位置：</span>
        <span class="name_title">{{ matterinfodata.path }}</span>
      </div>
    </div>
    <div
      v-if="matterinfotype === 'imgDetail' || matterinfotype === 'uploadImgDetail'"
      class="baseinfo_content"
    >
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">分辨率：</span>
          <span class="name">{{ matterinfodata.width }} * {{ matterinfodata.height }} px</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">尺寸：</span>
          <span class="name">{{ matterinfodata.widthAndHigh }}</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">构图：</span>
          <span class="name">{{ matterinfodata.composition }}</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">清晰度：</span>
          <span class="name">{{ matterinfodata.resolution }}dpi | {{ matterinfodata.sharpness }}</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">图片大小：</span>
          <span class="name">{{ (matterinfodata.size / 1024 / 1024).toFixed(2) }}MB</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">地理位置：</span>
          <span class="name">{{ matterinfodata.place_name }}</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item main_color">
          <span class="title">主色调：</span>
          <span
            class="main_color_span"
            :style="`background: #${(matterinfodata && matterinfodata.color) && matterinfodata.color.replace('0x', '')}`"
          ></span>
          <span class="name">{{ matterinfodata.color }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="matterinfotype === 'videoDetail' || matterinfotype === 'videoAuditDetail' || matterinfotype === 'uploadVideoDetail'"
      class="baseinfo_content"
      style="border-bottom:1px solid #E8E8E8;"
    >
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">帧高度：</span>
          <span class="name">{{ matterinfodata.frameWidth }} * {{ matterinfodata.frameHeight }} px</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">尺寸：</span>
          <span class="name">{{ matterinfodata.widthAndHigh }}</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">数据速率：</span>
          <span class="name">{{ matterinfodata.rate }}kbps</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">清晰度：</span>
          <span class="name">{{ matterinfodata.sharpness }}</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">总比特率：</span>
          <span class="name">{{ matterinfodata.bit }}kbps</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">帧速率：</span>
          <span class="name">{{ matterinfodata.chastity_rate }}帧/秒</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">文件格式：</span>
          <span class="name">{{ matterinfodata.format }}</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">文件大小：</span>
          <span class="name">{{ (matterinfodata.size / 1024 / 1024).toFixed(2) }}MB</span>
        </div>
      </div>
    </div>

    <div
      v-if="matterinfotype === 'videoDetail'  || matterinfotype === 'videoAuditDetail' || matterinfotype === 'uploadVideoDetail'"
      class="baseinfo_content"
      style="border-bottom:1px solid #E8E8E8;"
    >
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">音频频道：</span>
          <span class="name">{{ matterinfodata.radioChannel }}</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">音频采样：</span>
          <span class="name">{{ matterinfodata.audioSampling }}KHZ</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span
            class="title"
            style="width:100px;"
          >音频比特率：</span>
          <span class="name">{{ matterinfodata.radioBitRate }}kbps</span>
        </div>
      </div>
    </div>

    <div
      v-if="matterinfotype === 'audioDetail' || matterinfotype === 'uploadAudioDetail'"
      class="baseinfo_content"
    >
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span class="title">文件格式：</span>
          <span class="name">{{ matterinfodata.format }}</span>
        </div>
        <div class="baseinfo_content_each_item">
          <span class="title">文件大小：</span>
          <span class="name">{{ (matterinfodata.size / 1024 / 1024).toFixed(2) }}MB</span>
        </div>
      </div>
      <div class="baseinfo_content_each">
        <div class="baseinfo_content_each_item">
          <span
            class="title"
            style="width:100px;"
          >音频比特率：</span>
          <span class="name">{{ matterinfodata.radioBitRate }}kbps</span>
        </div>
      </div>

    </div>

  </el-scrollbar>
</template>

<script>

export default {
  components: {

  },
  props: {
    matterinfodata: {
      type: Object,
      required: true
    },
    matterinfotype: {
      type: String,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  mounted () {

  },
  destroyed () {

  },
  methods: {

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.baseinfo_list
  width 100%
  height 100%

  .baseinfo_top
    padding 16px 16px 0 16px
    border-bottom 1px solid #E8E8E8

    .baseinfo_each
      display flex
      margin-bottom 16px

      span
        font-size 14px

      .title
        display inline-block
        width 70px
        color #606266
        text-align justify
        text-align-last justify
        text-justify distribute-all-lines // 这行必加，兼容ie浏览器

      .name
        overflow hidden
        width 80%
        color #303133
        text-overflow ellipsis
        white-space nowrap

      .name_title
        width 80%
        color #303133
        word-break break-all

      .tags
        flex 1

        span
          margin-right 20px
          margin-bottom 20px
          color #688EFF

      .each_status
        span
          display inline-block
          padding 5px 10px
          border-radius 4px
          color #fff

        .yes
          background #6bd57c

        .no
          background #f56969

        .doing
          background #ffad2f

        .unAudit
          background #aaa

  .baseinfo_content
    padding 16px 0 16px 16px

    .baseinfo_content_each
      display flex
      margin-bottom 16px

      .baseinfo_content_each_item
        flex 1

        span
          font-size 14px

        .title
          display inline-block
          width 70px
          color #606266
          text-align justify
          text-align-last justify
          text-justify distribute-all-lines // 这行必加，兼容ie浏览器

        .name
          color #303133

      .main_color
        display flex

        .main_color_span
          display inline-block
          margin-right 10px
          width 16px
          height 16px
</style>
